import React from "react";
import { View, SafeAreaView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { AppText } from "./AppText";
import { Colors } from "@/constants/Colors";
import Icons from "@/assets/icons";
import { FontFamilies } from "@/constants/Typography";

const AppMaintaining = () => {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Icons.LogoBlack width={120} height={120} />
        </View>

        <AppText type="title" style={styles.title}>
          Under Maintenance
        </AppText>

        <AppText type="subtitle" style={styles.subtitle}>
          Sparrow is currently under maintenance
        </AppText>

        <AppText style={styles.description}>
          We are updating the app to bring you a better experience. Please check
          back in a few minutes.
        </AppText>

        <AppText style={styles.thankYou}>Thank you for your patience!</AppText>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
  },
  iconContainer: {
    marginBottom: 24,
  },
  title: {
    textAlign: "center",
    color: Colors.text,
    fontFamily: FontFamilies.Inter.Medium,
    marginBottom: 8,
  },
  subtitle: {
    textAlign: "center",
    color: Colors.icon,
    marginBottom: 24,
    fontFamily: FontFamilies.Inter.Regular,
  },
  description: {
    textAlign: "center",
    color: Colors.text,
    lineHeight: 24,
    marginBottom: 16,
    maxWidth: 300,
    fontFamily: FontFamilies.InterTight.Regular,
  },
  thankYou: {
    textAlign: "center",
    color: Colors.primary,
    fontWeight: "600",
    fontFamily: FontFamilies.InterTight.Medium,
  },
});

export default AppMaintaining;
